module.exports = __webpack_public_path__ + "static/zine-079553fd6d5e7bdab94aff63e69b9459.pdf";